import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faChevronRight, faHandPointRight, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { BoxBottomLink, ChevronLinkGap, ChevronLinkFocus, ChevronLink } from 'components/theme/Links'

export const BoxBottom = ({ href, label }) => (
  <BoxBottomLink to={href}>
    {label} <span><FontAwesomeIcon icon={faChevronRight} /></span>
  </BoxBottomLink>
)

export const ChevronDefault = ({ href, label }) => (
  <ChevronLink to={href}>
    {label} <i><FontAwesomeIcon icon={faChevronRight} /></i>
  </ChevronLink>
)

export const ChevronSpaced = ({ href, label }) => (
  <ChevronLinkGap to={href}>
    {label} <span><FontAwesomeIcon icon={faAngleDoubleRight} /></span>
  </ChevronLinkGap>
)

export const ChevronFocus = ({ href, label }) => (
  <ChevronLinkFocus to={href}>
    <span><FontAwesomeIcon icon={faHandPointRight} /></span> {label}
  </ChevronLinkFocus>
)

export const BulletPointDefault = ({ children }) => (
  <>
    <span><FontAwesomeIcon icon={faCheck} /></span>
    <span>{children}</span>
  </>
)

export const BulletPointDefaultHeader = ({ children }) => (
  <>
    <span><FontAwesomeIcon icon={faChevronRight} /></span>
    <span>{children}</span>
  </>
)